export default __webpack_public_path__ + "static/media/pinkzebra2020.fef78446.jpg";